import React from 'react';
import moment from 'moment';

import { NavLink, withRouter } from 'react-router-dom'

import SideBarNavigationLink from '../layout/SideBarNavigationLink';
import Loading from '../layout/Loading';

import styles from './list.scss';
import { Icon } from '../icons';

const List = ({ events, loading, activeEventId }) => {
  if(loading)
    return <Loading>Loading events</Loading>

  return (
    <ul className="event-list">
      {events.slice().sort((a, b) => new Date(a.event_date) - new Date(b.event_date)).map(event =>
        <SideBarNavigationLink key={event.id} to={`/organisations/${event.organisation_id}/events/${event.id}/schedules`} active ={activeEventId === event.id}>
          <Icon className="event-icon" style={{fill: event.color}}  type="calendar" />
          <div className="event-date" style={{color: event.color}}>
            {moment(event.event_date).format("DD-MM-YYYY")}
          </div>
          <div className="event-name" style={{color: event.color}}>
            {event.description}
          </div>
        </SideBarNavigationLink>
      )}
    </ul>
  )
}

export default List;



// WEBPACK FOOTER //
// ./src/components/events/List.js